import React from 'react';
import { Link } from 'react-router-dom';
import M from 'materialize-css';
M.AutoInit();

// import { connect } from 'react-redux';

const Footer = () => {
  return (
    <footer className="page-footer white">
      <div className=" white">
        <div className="row">
          <div className="col s1 offset-s1">
            {/* <a className='btn-floating btn-large teal modal-trigger' href="#modal1"><i className="material-icons">flight</i></a>

            <div id="modal1" className="modal bottom-sheet black-text">
              <div className="modal-content black-text">
                <h4>How to create NDA?</h4>
                <p>create new NDA</p>
              </div>
              <div className="modal-footer">
                <a href="#!" className="modal-close waves-effect waves-green btn-flat">Got it</a>
              </div>
            </div> */}
          </div>
          <div className="col s8">
            <Link to="/"><h5 className="grey-text center-align">Cusaly</h5></Link>
            <div className="center-align">
              <a className="waves-effect waves-light btn-flat grey-text" href="mailto:test@ninjaplatform.com">Feature request</a>
              {/* <a className="waves-effect waves-light btn-flat grey-text">Q&A</a> */}
              <Link className="waves-effect waves-light btn-flat grey-text" to='help'>Q&A</Link>
              <Link className="waves-effect waves-light btn-flat grey-text" to='team'>TEAM</Link>
              <Link className="waves-effect waves-light btn-flat grey-text" to='plans'>PLANS & PRICING</Link>
            </div>
          </div>

          <div className="col s2">
            {/* <a className='btn-floating btn-large teal modal-trigger' href="#modal1"><i className="material-icons">flight</i></a>

            <div id="modal1" className="modal bottom-sheet">
              <div className="modal-content">
                <h4>How to create NDA?</h4>
                <p>create new NDA</p>
              </div>
              <div className="modal-footer">
                <a href="#!" className="modal-close waves-effect waves-green btn-flat">Got it</a>
              </div>
            </div> */}
          </div>
        </div>
      </div>
      <div className="footer-copyright white">
        <div className="container grey-text white">
          ©2018 Interacthub GmbH. Interacthub is not a law firm, does not provide legal services or advice, and does not provide or participate in legal representation.   Terms  Credits
        </div>
      </div>
    </footer >
  )
};

export default Footer;
